import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { FIRESTORE_PROXY_URL, FILE_BASE_URL } from "../config";
import "../styles/LessonDetails.css"; // استيراد التنسيق

const LessonDetails = () => {
  const { courseId, lessonId } = useParams();
  const [lesson, setLesson] = useState(null);

  useEffect(() => {
    const fetchLessonDetails = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("❌ لم يتم تسجيل الدخول. الرجاء تسجيل الدخول أولاً.");
        return;
      }

      try {
        // ✅ جلب بيانات المحاضرة عبر Cloudflare Worker Proxy
        const response = await fetch(`${FIRESTORE_PROXY_URL}/Courses/${courseId}/Lessons/${lessonId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`,
          },
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error?.message || "❌ فشل جلب بيانات المحاضرة.");
        }

        setLesson(data);
      } catch (error) {
        console.error("❌ حدث خطأ أثناء جلب تفاصيل المحاضرة:", error);
        alert("⚠️ حدث خطأ أثناء جلب بيانات المحاضرة.");
      }
    };

    fetchLessonDetails();
  }, [courseId, lessonId]);

  if (!lesson) {
    return <p className="no-content">⚠️ لا توجد تفاصيل متاحة لهذه المحاضرة.</p>;
  }

  return (
    <div className="lesson-container">
      <h2 className="lesson-title">📖 {lesson.title}</h2>
      <p className="lesson-description">{lesson.description}</p>

      {lesson.content_url || lesson.file_path ? (
        <a href={lesson.content_url || `${FILE_BASE_URL}${lesson.file_path}`} target="_blank" rel="noopener noreferrer" className="lesson-link">
          📄 عرض المحاضرة (ملف)
        </a>
      ) : null}

      <div className="lesson-content" dangerouslySetInnerHTML={{ __html: lesson.content || "❌ لا يوجد محتوى نصي للمحاضرة." }} />

      <Link to={`/Courses/${courseId}`} className="back-button">
        ⬅️ العودة إلى تفاصيل الدورة
      </Link>
    </div>
  );
};

export default LessonDetails;
